import { SearchBoxBackgroundImage } from '@/config';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {};

export default function SearchBoxLoading({}: Props) {
  return (
    <section className="pt-20 pb-20 bg-light-2 masthead -type-1 z-5">
      <div className="masthead__bg">
        <img alt="logo" src={SearchBoxBackgroundImage} className="js-lazy" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Skeleton height={80} className="mainSearch -col-3-big bg-white px-10 py-10 lg:px-20 lg:pt-5 lg:pb-20 rounded-4" />
          </div>
        </div>
      </div>
    </section>
  );
}
